export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10063.8eabdf83.jpg";